<div class="buyer-agent-container">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <form #buyerAgentForm="ngForm" class="buyer-agent-form">
    <div class="section-header mb-3">
      <h5>Buyer's Real Estate Agent</h5>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="noRealEstateAgent"
            name="noRealEstateAgent"
            [(ngModel)]="formData.noRealEstateAgent">
          <label class="form-check-label" for="noRealEstateAgent">
            No Real Estate Agent
          </label>
        </div>
      </div>
    </div>

    @if (!formData.noRealEstateAgent) {
      <div class="section-subheader mb-3">
        <h6>Company Information</h6>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerCompanyName">Company Name</label>
            <div class="col-md-9">
              <text-input
                id="buyerCompanyName"
                name="buyerCompanyName"
                [(ngModel)]="formData.companyName"
                maxlength="100"
                [required]="!formData.noRealEstateAgent">
              </text-input>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerCompanyLicenseId">Company License ID</label>
            <div class="col-md-9">
              <text-input
                     id="buyerCompanyLicenseId"
                     name="buyerCompanyLicenseId"
                     [(ngModel)]="formData.companyLicenseId"
                     maxlength="50">
              </text-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerAddress">Address</label>
            <div class="col-md-9">
              <text-input
                     id="buyerAddress"
                     name="buyerAddress"
                     [(ngModel)]="formData.address"
                     maxlength="200">
              </text-input>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerCity">City</label>
            <div class="col-md-9">
              <text-input
                     id="buyerCity"
                     name="buyerCity"
                     [(ngModel)]="formData.city"
                     maxlength="100">
              </text-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerState">State</label>
            <div class="col-md-9">
              <select class="form-select"
                      id="buyerState"
                      name="buyerState"
                      [(ngModel)]="formData.state">
                <option value="">-- Select State --</option>
                @for (state of states; track state.value) {
                  <option [value]="state.value">
                    {{ state.name }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerZip">Zip</label>
            <div class="col-md-9">
              <text-input
                     id="buyerZip"
                     name="buyerZip"
                     [(ngModel)]="formData.zip"
                     maxlength="20">
              </text-input>
            </div>
          </div>
        </div>
      </div>

      <div class="section-subheader mb-3 mt-4">
        <h6>Contact Information</h6>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerContactName">Contact Name</label>
            <div class="col-md-9">
              <text-input
                     name="buyerContactName"
                     id="buyerContactName"
                     [(ngModel)]="formData.contactName"
                     maxlength="100"
                     [required]="!formData.noRealEstateAgent">
              </text-input>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerContactLicense">Contact License</label>
            <div class="col-md-9">
              <text-input
                     name="buyerContactLicense"
                     id="buyerContactLicense"
                     [(ngModel)]="formData.contactLicense"
                     maxlength="50"
                     [required]="!formData.noRealEstateAgent">
              </text-input>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerContactEmail">Contact Email</label>
            <div class="col-md-9">
              <input class="form-control"
                     type="email"
                     name="buyerContactEmail"
                     id="buyerContactEmail"
                     #buyerContactEmail="ngModel"
                     [(ngModel)]="formData.contactEmail"
                     [ngClass]="{'is-invalid': buyerContactEmail && buyerContactEmail.touched && buyerContactEmail.invalid}"
                     [required]="!formData.noRealEstateAgent"
                     maxlength="100"
                     email/>
              <div class="invalid-feedback">
                Please enter a valid email address
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-3">
          <div class="row">
            <label class="col-md-3 col-form-label" for="buyerContactPhone">Contact Phone</label>
            <div class="col-md-9">
              <input class="form-control"
                     name="buyerContactPhone"
                     id="buyerContactPhone"
                     #buyerContactPhone="ngModel"
                     [(ngModel)]="formData.contactPhone"
                     [ngClass]="{'is-invalid': buyerContactPhone && buyerContactPhone.touched && buyerContactPhone.invalid}"
                     [mask]="'(000) 000-0000'"
                     [showMaskTyped]="true"
                     [required]="!formData.noRealEstateAgent"/>
              <div class="invalid-feedback">
                Please enter a valid phone number.
              </div>
            </div>
          </div>
        </div>
      </div>
    }

  </form>
</div>
